function findObjectByIndex(obj, i) {
  return obj[i];
}

export default findObjectByIndex;
